import { Link } from "react-router-dom";
import { TrendingUp, Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="flex items-center space-x-1 text-bitcoin-orange">
                <div className="text-2xl font-bold">₿</div>
                <TrendingUp className="h-5 w-5" />
              </div>
              <div className="font-bold text-lg">Chief Bitcoin Officer</div>
            </div>
            <p className="text-primary-foreground/80 text-sm leading-relaxed">
              Expert Bitcoin advisory services for real estate investors. Bridging traditional 
              real estate with Bitcoin strategies.
            </p>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-primary-foreground/80 hover:text-bitcoin-orange transition-colors text-sm">
                  Investment Strategies
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-primary-foreground/80 hover:text-bitcoin-orange transition-colors text-sm">
                  Custody Solutions
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-primary-foreground/80 hover:text-bitcoin-orange transition-colors text-sm">
                  Policy Development
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-primary-foreground/80 hover:text-bitcoin-orange transition-colors text-sm">
                  Financial Reporting
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/blog" className="text-primary-foreground/80 hover:text-bitcoin-orange transition-colors text-sm">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/glossary" className="text-primary-foreground/80 hover:text-bitcoin-orange transition-colors text-sm">
                  Bitcoin Glossary
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-primary-foreground/80 hover:text-bitcoin-orange transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-primary-foreground/80 hover:text-bitcoin-orange transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-2 text-sm text-primary-foreground/80">
                <Mail className="h-4 w-4" />
                <span>info@chiefbitcoinofficer.com</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-primary-foreground/80">
                <Phone className="h-4 w-4" />
                <span>+1 (555) 123-4567</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-primary-foreground/80">
                <MapPin className="h-4 w-4" />
                <span>Nationwide Service</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-primary-foreground/60 text-sm">
              © {new Date().getFullYear()} Chief Bitcoin Officer. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/privacy" className="text-primary-foreground/60 hover:text-bitcoin-orange transition-colors text-sm">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-primary-foreground/60 hover:text-bitcoin-orange transition-colors text-sm">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;